import React, {Fragment, useEffect, useState} from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import LoadingSpinner from "../components/LoadingSpinner.js";
import config from "../config";
import { genericErrorMsg } from "../utils.js";
import dayjs from 'dayjs';

const ICONS = {
  breakfast: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3v2M4.2 10.2 5.6 11.6M18.4 11.6l1.4-1.4M3 18h18M6 18a6 6 0 0 1 12 0" />
    </svg>
  ),
  lunch: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </svg>
  ),
  dinner: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
    </svg>
  )
};

const MEALS = ['breakfast', 'lunch', 'dinner'];
const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

function DayCard({ day, potl, visitors }) {
  return (
    <article className="sp-card">
      <span className="sp-day">{day}</span>

      <div className="sp-hero">
        <div className="sp-stat">
          <span className="sp-num">{potl}</span>
          <span className="sp-hero-label">Team &amp; Guests</span>
        </div>
        <div className="sp-stat">
          <span className="sp-num">{visitors.total}</span>
          <span className="sp-hero-label">Visitors</span>
        </div>
      </div>

      <div className="sp-divider" />

      <div className="sp-meals">
        {MEALS.map((k) => (
          <div className="sp-meal" key={k}>
            {ICONS[k]}
            <span className="sp-meal-num">{visitors[k] + potl}</span>
            <span className="sp-meal-label">{cap(k)}</span>
          </div>
        ))}
      </div>
    </article>
  );
}

export default function PotlPublicPage() {

  const [potlData, setPotlData] = useState(null);

  const fetchPotlData = () => {
    fetch(`${config.server_base_url}/api/potl`)
      .then((response) => response.json())
      .then((data) => setPotlData(data.potlData))
      .catch(() => toast.error(genericErrorMsg, { theme: 'colored' }));
  };

  useEffect(() => {
    fetchPotlData();
  }, []);

  return (
    <div className="app-container my-booking-app">
      <div className="page-container my-booking-page public-potl-page">
        {potlData ?
          <Fragment>
            <h1 style={{marginBottom: '2rem'}}>People on the land<br/> {dayjs().format('ddd, MMM D')}</h1>
            <div className="sahaja-potl" id="sahaja-potl">
              <div className="sp-grid">
                <DayCard day="Today" potl={potlData.potlToday} visitors={potlData.visitorsToday} />
                <DayCard day="Tomorrow" potl={potlData.potlTomorrow} visitors={potlData.visitorsTomorrow} />
              </div>
            </div>
          </Fragment> : <Fragment><center><LoadingSpinner /></center></Fragment>}
      </div>
      <ToastContainer />
    </div>
  );
}